import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import '../styles/FormConfigs.css';

function FormConfigs() {
  const navigate = useNavigate();
  const [configs, setConfigs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadConfigs();
  }, []);

  const loadConfigs = async () => {
    try {
      setLoading(true);
      const response = await api.getFormConfigs(false);
      setConfigs(response.data || []);
      setError('');
    } catch (err) {
      setError('Failed to load form configurations: ' + err.message);
      console.error('Error loading configs:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (configId) => {
    navigate(`/form-configs/edit/${configId}`);
  };

  const handleDuplicate = async (configId) => {
    if (!window.confirm('Are you sure you want to duplicate this configuration?')) {
      return;
    }

    try {
      await api.duplicateFormConfig(configId);
      setError('');
      alert('Configuration duplicated successfully!');
      loadConfigs();
    } catch (err) {
      setError('Failed to duplicate configuration: ' + err.message);
    }
  };

  const handleDelete = async (configId) => {
    if (!window.confirm('Are you sure you want to delete this configuration?')) {
      return;
    }

    try {
      await api.deleteFormConfig(configId);
      setError('');
      alert('Configuration deleted successfully!');
      loadConfigs();
    } catch (err) {
      setError('Failed to delete configuration: ' + err.message);
    }
  };

  if (loading) {
    return <div className="form-configs-container"><div className="loading">Loading...</div></div>;
  }

  return (
    <div className="form-configs-container">
      <div className="form-configs-header">
        <h1>Form Configurations</h1>
        <button className="btn btn-primary" onClick={() => navigate('/form-configs/new')}>
          Create New Config
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {configs.length === 0 ? (
        <div className="no-configs">
          <p>No form configurations found</p>
          <button className="btn btn-primary" onClick={() => navigate('/form-configs/new')}>
            Create Your First Config
          </button>
        </div>
      ) : (
        <div className="configs-grid">
          {configs.map((config) => (
            <div key={config.id} className={`config-card ${!config.is_active ? 'inactive' : ''}`}>
              <div className="config-header">
                <h3>{config.form_title || config.title || 'Untitled'}</h3>
                <span className={`status-badge ${config.is_active ? 'active' : 'inactive'}`}>
                  {config.is_active ? 'Active' : 'Inactive'}
                </span>
              </div>
              <div className="config-body">
                <div className="config-key">
                  {config.config_key || config.key}
                </div>
                <p className="config-description">
                  {config.form_description || config.description || 'No description provided'}
                </p>
                <div className="config-meta">
                  Updated: {new Date(config.updated_at).toLocaleDateString()}
                </div>
              </div>
              <div className="config-actions">
                <button
                  onClick={() => handleEdit(config.id)}
                  className="btn btn-sm btn-secondary"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDuplicate(config.id)}
                  className="btn btn-sm btn-secondary"
                >
                  Duplicate
                </button>
                <button
                  onClick={() => handleDelete(config.id)}
                  className="btn btn-sm btn-danger"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default FormConfigs;
